import { el, clear } from './dom.js';

/** 読み込み状況とエラーを出す全面オーバーレイ。 */
export function createLoadingOverlay(container) {
  const message = el('p', { class: 'ov-msg' }, '物件データを読み込んでいます…');
  const bar = el('div', { class: 'ov-bar-fill' });
  const barWrap = el('div', { class: 'ov-bar' }, bar);
  const body = el('div', { class: 'ov-body' }, [message, barWrap]);
  const root = el('div', { class: 'ov' }, body);
  container.appendChild(root);

  return {
    setMessage(text) {
      message.textContent = text;
    },
    setProgress(ratio) {
      if (ratio === null || ratio === undefined) {
        barWrap.classList.add('is-indeterminate');
        return;
      }
      barWrap.classList.remove('is-indeterminate');
      bar.style.width = `${Math.round(Math.min(Math.max(ratio, 0), 1) * 100)}%`;
    },
    /** ユーザーには読める言葉で出し、詳細は開発者コンソールに残す */
    fail(error, { link = null } = {}) {
      console.error('[naiken-3dgs]', error);
      root.classList.add('is-error');
      clear(body);
      body.append(
        el('p', { class: 'ov-msg' }, '読み込みできませんでした'),
        el('p', { class: 'ov-detail' }, error instanceof Error ? error.message : String(error)),
        el('button', { class: 'btn', onClick: () => window.location.reload() }, '再読み込み'),
      );
      // 物件が見つからないときなどに、一覧へ戻れるようにする
      if (link !== null) body.append(el('a', { class: 'ov-link', href: link.href }, link.label));
    },
    hide() {
      root.classList.add('is-hidden');
      setTimeout(() => root.remove(), 400);
    },
  };
}
